module.exports = __webpack_public_path__ + "img/social-tropical-cocktail.0a13d1be.jpg";